export default function (state, payload) {
  return {
    ...state,
    flyoutOpen: payload.value,
  }
}
